<template>
  <button
    @click="clearFilter"
    @keypress="clearFilterFromKeyPress"
    tabindex="0"
    class="button button-no-style button-close-icon filters__clear-filters"
  >
    <span class="icon icon-close-circle"></span>
    Clear all filters
  </button>
</template>

<script>
import Vue from "vue";

export default Vue.component("FiltersClear", {
  props: {
    clearAllFilters: Function,
    clearFiltersText: String,
  },
  methods: {
    clearFilter: function() {
      this.clearAllFilters();
      document.getElementById("Regions").selectedIndex = 0;
    },
    clearFilterFromKeyPress: function(event) {
      if (event.keyCode == 32 || event.keyCode == 13) {
        this.clearAllFilters();
        document.getElementById("Regions").selectedIndex = 0;
      }
      event.preventDefault();
    },
  },
});
</script>
